import { useNavigate } from "react-router-dom";
import { MenuItems } from "Utils/Constants/MenuItems";
import { move2Top } from "Utils/Helpers/ApiServices";
import * as Icons from "react-bootstrap-icons";
import { useState } from "react";
import Logo from "Utils/Assets/Images/Logo.png";
import SysLogo from "./Logo";

export default function MenuDrawer({ onClick }) {
  const navigate = useNavigate();

  const handlePush = (item) => {
    navigate(item.action);
    move2Top();
    try {
      onClick();
    } catch {}
  };

  return (
    <ul>
      {MenuItems.filter((item) => item.active).map((item) => {
        return (
          <li
            key={`menuItems-${item.id}`}
            onClick={() => handlePush(item)}
            className={
              window.location.pathname.split("/")[1] ===
              item.action.split("/")[1]
                ? "active"
                : ""
            }
          >
            {item.title_image ? (
              <SysLogo image={item.image} alt={item.title} />
            ) : (
              <p className="text-nowrap">{item.title}</p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
